<div class="container mt-4" [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'" style="page-break-inside: avoid;">
    <div class="row">
        <div class="col-12 text-center">
            <strong>৩০/৬/{{assessmentYearStart | convertNumWithOtherCharsToBn}} তারিখে সমাপ্ত আয়বর্ষের আয় ও আয়করের বিবরনী</strong>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-sm-5">
            করদাতার নাম: {{returnData?.profileData?.assesName}}
        </div>
        <div class="col-sm-7 text-right">
            টি আইএন:
            <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item | convertNumWithOtherCharsToBn}}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
            </span>
        </div>
    </div>
    <div class="row margin-amt">
        <div class="col-2">
        </div>
        <div class="col-5">
            <strong>মোট আয়ের বিবরণী</strong>
        </div>
        <div class="col-5 text-center">
            <strong>টাকার পরিমাণ</strong>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-12">
            <table class="table table-bordered">
                <tbody class="child-text-center">
                    <tr>
                        <td width="10%" class="text-center">১।</td>
                        <td width="60%">চাকরি হইতে আয় (এই রিটার্নের তফসিল ১ অনুযায়ী)</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_IFEMP_Amt | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">২।</td>
                        <td width="60%">ভাড়া হইতে আয় (এই রিটার্নের তফসিল ২ অনুযায়ী )</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_IFR_Amt | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">৩।</td>
                        <td width="60%">কৃষি হইতে আয় (এই রিটার্নের তফসিল ৩ অনুযায়ী )</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_IFA_Amt | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">৪।</td>
                        <td width="60%">ব্যবসা হইতে আয় (এই রিটার্নের তফসিল ৪ অনুযায়ী )</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_IFB_Amt | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">৫।</td>
                        <td width="60%">মূলধনি আয়</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_IFCG_Amt | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">৬।</td>
                        <td width="60%">আর্থিক পরিসম্পদ হইতে আয় (ব্যাংক সুদ / মুনাফা, লভ্যাং শ, সঞ্চয়পত্র মুনাফা,
                            সিকিউরিটিজ ইত্যাদি)</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_IFFA_Amt | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">৭।</td>
                        <td width="60%">অন্যান্য উৎস হইতে আয় (রয়্যালটি, লাইসেন্স ফি, সম্মানী, ফি, সরকার প্রদত্ত নগদ
                            ভর্তুকি ইত্যাদি)</td>
                        <td width="30%">{{ ( (returnData?.taxPaymentData?.poti_IFOS_Amt)  + (returnData?.taxPaymentData?.poti_IFOS_67_15 || 0) ) | formatNumberReturnView }}</td>
                    </tr>
                    <tr *ngIf="returnData?.taxPaymentData?.poti_Undisclosed_Amt && returnData?.taxPaymentData?.poti_Undisclosed_Amt > 0">
                        <td width="10%" class="text-center"></td>
                        <td width="60%">আয়ের স্বপ্রণোদিত ঘোষণা (প্রথম তফসিল)</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_Undisclosed_Amt | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">৮।</td>
                        <td width="60%">ফার্ম বা ব্যক্তিসংঘের আয়ের অংশ </td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_SOIFFAOP_Amt | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">৯।</td>
                        <td width="60%">অপ্রাপ্ত বয়স্ক সন্তান, স্ত্রী বা স্বামীর আয় (করদাতা না হইলে)</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_IFMSUS_Amt | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">১০।</td>
                        <td width="60%">বিদেশে উদ্ভূত করযোগ্য আয়</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_FI_Amt | formatNumberReturnView}}</td>
                    </tr>
                    <tr *ngIf="isCsrDonation">
                        <td width="10%" class="text-center"></td>
                        <td width="60%">ষষ্ঠ তফসিলের অংশ-২ অনুযায়ী দান</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_TOTAL_Allowable_CSR_Donation_Amt | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">১১।</td>
                        <td width="60%">মোট আয় (ক্রমিক ১ হইতে ১০ এর সমষ্টি<span *ngIf="isCsrDonation"> হইতে ষষ্ঠ তফসিলের অংশ-২ অনুযায়ী দান বাদে</span>)</td>
                        <td width="30%">{{returnData?.taxPaymentData?.poti_Total_Income_Amt | formatNumberReturnView}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- second table  -->
    <div class="row mt-4 mb-2">
        <div class="col-2">
        </div>
        <div class="col-5">
            <strong>কর পরিগণনা</strong>
        </div>
        <div class="col-5 text-center">
            <strong>টাকার পরিমাণ</strong>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-12">
            <table class="table table-bordered">
                <!-- <thead>
                    <tr>
                        <th>Column 1</th>
                        <th>Column 2</th>
                        <th>Column 3</th>
                    </tr>
                </thead> -->
                <tbody class="child-text-center">
                    <tr>
                        <td width="10%" class="text-center">১২।</td>
                        <td width="60%">মোট কর পরিগণনাযোগ্য আয়ের উপর আরোপযোগ্য আয়কর </td>
                        <td width="30%">{{returnData?.taxPaymentData?.tc_Gross_Tax_Before_Tax_Rebate_Amt | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">১৩।</td>
                        <td width="60%">কর রেয়াত(এই রিটার্নের তফসিল ৫ অনুযায়ী ) প্রণোদনা সহ</td>
                        <td width="30%">{{addIncentive(returnData?.taxPaymentData?.tc_Tax_Rebate_Amt) | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">১৪।</td>
                        <td width="60%">রেয়াত এবং প্রণোদনা-পরবর্তী প্রদেয় করদায় (১২-১৩)</td>
                        <td width="30%">{{reduceIncentive(returnData?.taxPaymentData?.tc_Net_Tax_After_Tax_Rebate_Amt) | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">১৫।</td>
                        <td width="60%">ন্যূনতম কর </td>
                        <td width="30%">{{returnData?.taxPaymentData?.tc_Min_Tax_Amt | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">১৬।</td>
                        <td width="60%">প্রদেয় কর (ক্রমিক ১৪ ও ক্রমিক ১৫ এর মধ্যে যাহা অধিক)</td>
                        <td width="30%">
                            {{
                                (reduceIncentive(returnData?.taxPaymentData?.tc_Net_Tax_After_Tax_Rebate_Amt) > returnData?.taxPaymentData?.tc_Min_Tax_Amt
                                ? reduceIncentive(returnData?.taxPaymentData?.tc_Net_Tax_After_Tax_Rebate_Amt)
                                : returnData?.taxPaymentData?.tc_Min_Tax_Amt) | formatNumberReturnView
                            }}
                        </td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">১৭।</td>
                        <td width="60%" style="padding:0px; border: none;">
                            <table class="table table-bordered" style="margin:0px">
                                <tr>
                                    <td width="70%">(ক)নিট পরিসম্পদের জন্য প্রদেয় সারচার্জ (প্রযোজ্য ক্ষেত্রে)</td>
                                    <td width="30%" class="text-center">{{returnData?.taxPaymentData?.tc_S_Net_Wealth_Surcharge | formatNumberReturnView}}</td>
                                </tr>
                                <tr>
                                    <td width="70%">(খ) তামাকজাত পণ্য সারচার্জ (প্রযোজ্য ক্ষেত্রে)</td>
                                    <td width="30%" class="text-center">{{returnData?.taxPaymentData?.tc_S_Tobacco_Surcharge | formatNumberReturnView}}</td>
                                </tr>
                                <tr>
                                    <td width="70%">(গ)পরিবেশ সারচার্জ (প্রযোজ্য ক্ষেত্রে)</td>
                                    <td width="30%" class="text-center">{{returnData?.taxPaymentData?.tc_S_Environmental_Surcharge | formatNumberReturnView}}</td>
                                </tr>
                            </table>
                        </td>
                        <td width="30%" class="text-center">
                            {{returnData?.taxPaymentData?.tc_Net_Wealth_Surcharge_Amt | formatNumberReturnView}}
                        </td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">১৮।</td>
                        <td width="60%">বিলম্ব সুদ, জরিমানা অথবা আয়কর আইনের অধীন প্রদেয় কোনো অঙ্ক (যদি থাকে)</td>
                        <td width="30%">{{returnData?.taxPaymentData?.tc_Undisclosed_Penalty_Amt | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="text-center">১৯।</td>
                        <td width="60%">মোট প্রদেয় কর (১৬+১৭+১৮)</td>
                        <td width="30%">{{returnData?.taxPaymentData?.tc_Total_Payable_Amt | formatNumberReturnView}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- third table -->
    <div style="page-break-inside: avoid">
        <div class="row mt-4 mb-2">
            <div class="col-2">
            </div>
            <div class="col-5">
                <strong>কর পরিশোধ বিবরণ</strong>
            </div>
            <div class="col-5 text-center">
                <strong>টাকার পরিমাণ</strong>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-12">
                <table class="table table-bordered">
                    <!-- <thead>
                        <tr>
                            <th>Column 1</th>
                            <th>Column 2</th>
                            <th>Column 3</th>
                        </tr>
                    </thead> -->
                    <tbody class="child-text-center">
                        <tr>
                            <td width="10%" class="text-center">২০।</td>
                            <td width="60%">উৎস কর্তিত/সংগৃহীত কর(প্রমাণাদি সংযুক্ত করুন) </td>
                            <td width="30%">{{returnData?.ledgerServiceInfo?.totalTDS | formatNumberReturnView}}</td>
                        </tr>
                        <tr>
                            <td width="10%" class="text-center">২১।</td>
                            <td width="60%">পরিশোধিত অগ্রিম কর (প্রমাণাদি সংযুক্ত করুন)</td>
                            <td width="30%">{{returnData?.ledgerServiceInfo?.totalAIT | formatNumberReturnView}}</td>
                        </tr>
                        <tr>
                            <td width="10%" class="text-center">২২।</td>
                            <td width="60%">প্রত্যার্পণযোগ্য করের সমন্বয় (যদি থাকে ) <br>
                                (প্রত্যার্পণ সংশ্লিষ্ট কর বর্ষ/ বর্ষসমূহ উল্লেখ করুন)
                            </td>
                            <td width="30%">{{returnData?.ledgerServiceInfo?.adjustedTaxAmount | formatNumberReturnView}}</td>
                        </tr>
                        <tr>
                            <td width="10%" class="text-center">২৩।</td>
                            <td width="60%">এই রিটার্ন এর সহিত পরিশোধিত অবশিষ্ট কর <br>
                                (প্রমাণাদি সংযুক্ত করুন)</td>
                            <td width="30%">{{(returnData?.ledgerServiceInfo?.regularPayment + returnData?.ledgerServiceInfo?.regularTaxPaid) | formatNumberReturnView}}</td>
                        </tr>
                        <tr>
                            <td width="10%" class="text-center">২৪।</td>
                            <td width="60%">প্রদত্ত কর(২০+২১+২২+২৩)</td>
                            <td width="30%">
                                {{
                                returnData?.paymentDetails?.totalAmount | formatNumberReturnView
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td width="10%" class="text-center">২৫।</td>
                            <td width="60%">অতিরিক্ত পরিশোধ</td>
                            <td width="30%">{{returnData?.taxPaymentData?.tc_S_Refundable | formatNumberReturnView}}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="row mb-4">
                    <div class="col-12">
                        <table class="table table-bordered">
                            <tr>
                                <td width="10%" class="text-center">২৬।</td>
                                <td width="60%">কর অব্যাহতিপ্রাপ্ত / করমুক্ত আয় (বিবরণ সংযুক্ত করুন) </td>
                                <td width="30%">{{returnData?.taxPaymentData?.poti_Tax_Exempted_Income_Amt | formatNumberReturnView}}</td>
                            </tr>
                        </table>
                    </div>

                </div>
            </div>
        </div>

        <!-- fourth table -->
        <div class="row">
            <div class="col-12">
              <div class="custom-box text-center">
                <strong>এই রিটার্নের সাথে দাখিলকৃত দলিলপত্রাদির তালিকা</strong>
                <div class="font-italic text-center">(অনলাইন সাবমিশনের ক্ষেত্রে দলিলপত্রাদির প্রয়োজন নেই)</div>
                <textarea *ngIf="inputEnable" class="form-control mt-2" rows="3" style="max-height: 340px; overflow-y: auto;"></textarea>
              </div>
            </div>
        </div>
        <div class="text-center mt-5">
            <strong> <u style="color: black;"> প্রতিপাদন</u> </strong>
        </div>
        <div class="container container-condensed">
            <div class="row mt-4">
                <!-- <div class="col-1"></div> -->
                <div class="col-6 pl-2">
                    আমি {{returnData?.profileData?.assesName}}
                </div>
                <div class="col-6 text-right pr-2">
                    পিতা/স্বামী: {{returnData?.profileData?.fathersName}}
                </div>
            </div>

            <div class="row my-4">
                <div class="col-12" style="line-height: 30px;">
                    টি আইএন
                    <span class="mx-2">
                        <input value="{{item | convertNumWithOtherCharsToBn}}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
                    </span>
                    ঘোষণা করিতেছি যে, এই রিটার্ন এবং বিবরণী ও সংযুক্ত প্রমাণাদিতে প্রদত্ত তথ্য
                        আমার বিশ্বাস ও জ্ঞান মতে সঠিক ও
                        সম্পূর্ণ।
                </div>
            </div>

            <div class="row pt-5">
                <div class="col-6">
                    স্থান:<br>
                    তারিখ:{{dateWithSign}}
                </div>
                <div class="col-6 text-center">
                    {{returnData?.profileData?.assesName}} <br>
                    ..................................................... <br>
                    স্বাক্ষর <br>
                    (স্পষ্টাক্ষরে নাম) <br>
                    ব্যক্তি না হইলে পদবি ও সিল মোহর <br>
                    <div class="font-weight-bold font-italic mt-1">সিস্টেম জেনারেটেড ডকুমেন্ট। স্বাক্ষরের প্রয়োজন নেই।</div>
                </div>
            </div>
        </div>
    </div>
</div>
